import { Component, Input } from 'ng-metadata/core';
import './step.component.scss';

/**
* @ngdoc directive
* @name mwStep
* @module mw.components.stepper
*
* @param {number} [stepId] - The user defined ID of the step.
* @param {string} [stepLabel] - The label of the step.
* @param {boolean} [active=false] - A boolean indicating if the step is active.
* @param {boolean} [completed=false] - A boolean indicating if the step is completed.  Will show a checkmark if completed is true.
*
* @description
* `<mw-step>` is a component to display an individual step within a stepper component
*
* @usage
* <hljs hljs-language="html">
*  <mw-stepper>
*      <mw-stepper-desktop-header ng-if="!$mdMedia('xs')" layout="row" layout-align="center center">
*		   <mw-step step-id="data[0].id" step-label="data[0].label" active="data[0].active" completed="data[0].completed"></mw-step>
*		   <mw-stepper-divider flex></mw-stepper-divider>
*		   <mw-step step-id="data[1].id" step-label="data[1].label" active="data[1].active" completed="data[1].completed"></mw-step>
*		   <mw-stepper-divider flex></mw-stepper-divider>
*		   <mw-step step-id="data[2].id" step-label="data[2].label" active="data[2].active" completed="data[2].completed"></mw-step>
*		   <mw-stepper-divider flex></mw-stepper-divider>
*		   <mw-step step-id="data[3].id" step-label="data[3].label" active="data[3].active" completed="data[3].completed"></mw-step>
*		   <mw-stepper-divider flex></mw-stepper-divider>
*		   <mw-step step-id="data[4].id" step-label="data[4].label" active="data[4].active" completed="data[4].completed"></mw-step>
*	   </mw-stepper-desktop-header>
*	   <mw-stepper-mobile-header ng-if="$mdMedia('xs')">
*		   Step {{currentStep.id}} of {{data.length}}
*	   </mw-stepper-mobile-header>
*  </mw-stepper>
* </hljs>
*
*/
@Component({
    selector: 'mw-step',
    template: `
        <div class="mw-step__container" ng-class="{'mw-step--completed':$ctrl.completed, 'mw-step--active':$ctrl.active }" layout="row">
            <div class="mw-step__icon" ng-class="{'mw-step__icon--active': $ctrl.active}" flex="none">
                {{$ctrl.stepId}}
            </div>
            <div class="mw-step__icon--completed" flex="none">
                <md-icon md-svg-icon="navigation:ic_check_24px"></md-icon>
            </div>
            <div class="mw-step__label" ng-class="{'mw-step__label--active': $ctrl.active, 'mw-step__label--completed': $ctrl.completed}" data-label="{{$ctrl.stepLabel}}" flex="auto">
                {{$ctrl.stepLabel}}
            </div>
		</div>
	`
})
export class StepComponent {
    @Input('<') stepId: number;
    @Input('<') stepLabel: string;
    @Input('<') active: boolean = false;
    @Input('<') completed: boolean = false;

    constructor () {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/stepper/step.component.ts